import React, { useState, useContext } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import 'bulma/css/bulma.min.css';

import { EsafDto, updateEsaf } from '../api/api.ts';
import { SampleSetsContext } from '../sampleSetsProvider.tsx';


const ArchiveEsaf: React.FC = () => {

  const sampleSetsContext = useContext(SampleSetsContext);
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [archive, setArchive] = useState<boolean>(false);

  const [inProgress, setInProgress] = useState<boolean>(false);
  const [submitErrorMessage, setSubmitErrorMessage] = useState<string | null>(null);

  function getEsaf(): EsafDto | undefined {
    return sampleSetsContext.esaf;
  }

  function clickedOpen() {
    const thisEsaf = getEsaf();
    if (!inProgress && !isOpen && thisEsaf) {
      setIsOpen(true);
      setArchive(thisEsaf.archived);
    }
  }

  async function pressedSubmit() {
    const thisEsaf = getEsaf();
    if (!thisEsaf) { return; }

    setSubmitErrorMessage(null);
    setInProgress(true);

    const result = await updateEsaf({slug: thisEsaf.slug, archived: archive});
    setInProgress(false);
    if (!result.success) {
      setSubmitErrorMessage(result.message || "");
    } else {
      thisEsaf.archived = archive;
      sampleSetsContext.changed();
      setIsOpen(false);
//      navigate('../', { relative: "route" });
    }
  };

  function clickedClose() {
    if (!inProgress) { setSubmitErrorMessage(null); setIsOpen(false); }
  }

  return (
    <a className="dropdown-item" onClick={ clickedOpen }>Archive Status

      <div id="modal-add-sample" className={ isOpen ? "modal is-active" : "modal" }>
        <div className="modal-background"></div>

        <div className="modal-card">
          <header className="modal-card-head">
            <p className="modal-card-title">Archive ESAF</p>
            <button className="delete" aria-label="close" onClick={ clickedClose }></button>

          </header>
          <section className="modal-card-body">

            <div className="block">
              <p>
                Setting this ESAF as archived will hide it on the home page.
              </p>
              <p>
                All the sample information will remain intact, and you can un-archive it any time.
              </p>
            </div>

            <div className="block">
              <div className="field">
                <div className="control">
                  <label className="checkbox">
                    <input type="checkbox" checked={archive} onChange={() => setArchive(!archive)} style={{ "marginRight": "0.5em" }} />
                    Archived
                  </label>
                </div>
              </div>
            </div>

            <div className="buttons">
              <input
                type="button"
                className="button is-primary"
                onClick={ pressedSubmit }
                disabled={ inProgress }
                value="Set"
              />
              <button className="button" onClick={ clickedClose }>Cancel</button>
            </div>

            { submitErrorMessage && (
              <article className="message is-danger">
                <div className="message-body">
                  { submitErrorMessage }
                </div>
              </article>
            )}

          </section>

        </div>
      </div>

    </a>
  )
}
export default ArchiveEsaf
